export enum AppEnum{
  FactoryName= 'TranslateAppName',
  Home= 'HomeApp',
  Jobs= 'JobsApp',
  Network= 'NetworkApp',
  Resume= 'ResumeApp',
  Learning= 'LearningApp',
  Testing= 'TestingApp'
}
